import { IFilters } from "../../../Search/elements/FiltersMenu/FiltersMenu";

const getPageUrl = (endpoint: string, pageSize: number, page: number, filters?: IFilters) => {
  const params = new URLSearchParams();
  params.append("pageSize", pageSize.toString());
  params.append("page", page.toString());

  if (filters) {
    const filterKeys = Object.keys(filters) as (keyof IFilters)[];
    filterKeys.forEach((key) => {
      const value = filters[key];
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value.toString());
      }
    });
  }

  return `${endpoint}?${params.toString()}`;
};

export default getPageUrl;
